export const namespace = true;

export const state = {
    country: 'us',
    language: 'en',
};

export const getters = {
    country: state => state.country,
    language: state => state.language,
    path: state => '/' + state.language + '/' + state.country + '/',
    isDefault: state => state.country === 'us' && state.language === 'en',
};

export const mutations = {
    /**
     * Mutate the localization country and state values.
     *
     * @param  {Object} state             The Vuex state container.
     * @param  {String} options.country   The browser defined country.
     * @param  {String} options.language  The browser defined language.
     */
    set: (state, { country, language }) => {
        state.country = country;
        state.language = language;
    },
};

export const actions = {
    /**
     * This is automatically run in `src/state/store.js` when the app starts, along with any other actions named `init` in other modules.
     *
     * @param {Function} options.dispatch The Vuex state dispatch function for performing actions.
     */
    init ({ dispatch }) {
        const matches = (window.location.pathname.match(/^\/(\w\w)\/(\w\w)\//) || []);

        dispatch('update', {
            country: matches[2] || state.country,
            language: matches[1] || state.language,
        });
    },

    /**
     * The dispatchable action to update the localization properties.
     *
     * @param  {Function} options.commit The Vuex state commit function.
     * @param  {Object}   data           The localization data object.
     */
    update: ({ commit }, data) => {
        commit('set', data);
    },
};
